import { render, staticRenderFns } from "./dd_check.vue?vue&type=template&id=609152be&"
import script from "./dd_check.vue?vue&type=script&lang=js&"
export * from "./dd_check.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports